import { useEffect, useState } from "react";
import { Button, DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import SelectInput from "./SelectInput";
import { GenericObjectArrayType, TOption } from "../../types/common";
import { TableFilterProps } from "../../types/table";
import FilterForm from "../pages/reports/FilterForm";
import { openModal } from "../../utils/modalUtils";
import { SettingsOutline } from "@raresail/react-ionicons";
import { DATE_FORMAT } from "../../utils/constants";

const { RangePicker } = DatePicker;

export const TableFilter = (props: TableFilterProps) => {
  const {
    name,
    onChange,
    updateFilterValues: setFilters,
    filters,
    type,
    selectOptions,
    showHeaders = false,
    header,
    startDateKey,
    endDateKey,
  } = props;
  const [options, setOptions] = useState<TOption[]>([]);

  const updateFilterValues = (obj: any) => {
    setFilters({ ...filters, ...obj });
  };

  useEffect(() => {
    if (selectOptions) {
      const options = selectOptions || [];
      setOptions(
        options.map((sub: GenericObjectArrayType) => ({
          value: sub.id,
          label: sub.name,
        })),
      );
    }
  }, [selectOptions]);

  function handleFilter() {
    openModal({
      title: "Select filter",
      type: "form",
      formId: "filter-form",
      body: (
        <FilterForm
          filterOptions={{
            startDateKey: startDateKey || `${name}_min_date`,
            endDateKey: endDateKey || `${name}_max_date`,
          }}
        />
      ),
      okText: "Apply",
    })
      .then(({ currValue, stringValue }: any) => {
        updateFilterValues({ ...currValue, stringValue });
      })
      .catch(() => {});
  }

  const TitleText = () => {
    return (
      <div className="capitalize font12 mb-1">Filter by {header || name} </div>
    );
  };

  if (type === "select")
    return (
      <div style={{ minWidth: 200 }}>
        {showHeaders && <TitleText />}
        <SelectInput
          options={options}
          name={name}
          value={
            isNaN(filters?.[name] as any)
              ? filters?.[name]
              : Number(filters?.[name])
          }
          onChange={(value) => onChange(name, value)}
          label={""}
          // placeholder={`Search ${header || name}`}
          error={{}}
        />
      </div>
    );

  if (type === "date") {
    const startKey = startDateKey || `${name}_after`;
    const endKey = endDateKey || `${name}_before`;
    return (
      <div>
        {showHeaders && <TitleText />}
        <RangePicker
          onChange={(value: any) => {
            updateFilterValues({
              [startKey]: value?.[0]?.format("YYYY-MM-DD") || null,
              [endKey]: value?.[1]?.format("YYYY-MM-DD") || null,
            });
          }}
          format={DATE_FORMAT}
          value={[
            filters?.[startKey] ? dayjs(filters?.[startKey]) : null,
            filters?.[endKey] ? dayjs(filters?.[endKey]) : null,
          ]}
          style={{ height: 40 }}
        />
      </div>
    );
  }
  if (type === "date_select") {
    return (
      <div>
        {showHeaders && <TitleText />}
        <Button onClick={handleFilter}>
          <SettingsOutline />
          Filter
        </Button>
      </div>
    );
  }

  if (type === "number_range") {
    return (
      <div style={{ width: "100%" }}>
        {showHeaders && <TitleText />}
        <div
          style={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            width: "100%",
          }}
        >
          <InputNumber
            placeholder="Min"
            value={
              filters?.[`${name}_min`] ? Number(filters[`${name}_min`]) : null
            }
            onBlur={(event) => {
              const value = event.target.value;
              updateFilterValues({
                [`${name}_min`]: value !== null ? value : null,
              });
            }}
            style={{
              flex: 1,
              fontSize: 12,
              minWidth: 0,
            }}
            controls={false}
            size="small"
          />
          <span
            style={{
              fontSize: 10,
              color: "#999",
              flexShrink: 0,
              padding: "0 2px",
            }}
          >
            -
          </span>
          <InputNumber
            placeholder="Max"
            value={
              filters?.[`${name}_max`] ? Number(filters[`${name}_max`]) : null
            }
            onBlur={(event) => {
              const value = event.target.value;
              updateFilterValues({
                [`${name}_max`]: value !== null ? value : null,
              });
            }}
            style={{
              flex: 1,
              fontSize: 12,
              minWidth: 0,
            }}
            controls={false}
            size="small"
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      {showHeaders && <TitleText />}
      <input
        type="text"
        className="form-control"
        name={name}
        onBlur={(event) => onChange(name, event.target.value)}
        style={{ fontSize: 13 }}
        placeholder={showHeaders ? `Search ${header || name}` : ""}
      />
    </div>
  );
};
